/**
 * 
 */
export default class RestApi {
  auth = {
    login: (data) => $app.api.post([ 'admin/auth/login', ]).data(data),
    info: () => $app.api.get([ 'auth/info', ]),
  }
  
  users = {
    get: (id) => $app.api.get([ 'users*', id, ]),
    getOne: (id) => $app.api.get([ 'users*', id, ]),
    edit: (userId, data) => $app.api.patch([ 'users*', userId, ]).data(data),
    editAdmin: (userId, data) => $app.api.patch([ 'users/admin*', userId, ]).data(data),
    editPass: (id, data) => $app.api.patch([ 'users*/edit-password', id, ]).data(data),
    editPosition: (id, data) => $app.api.post([ 'users*/now-seller', id, ]).data(data),
  }
  additionals = {
    get: () => $app.api.get([ 'additionals', ]),
    edit: (id, data) => $app.api.patch([ 'additionals*', id, ]).data(data),
  }

  orders = {
    get: (id) => $app.api.get([ 'orders*', id, ]),
    getAll: () => $app.api.get([ 'all/orders', ]),
    getById: (id) => $app.api.get([ 'by*/orders', id, ]),
    edit: (userId, data) => $app.api.patch([ 'orders*', userId, ]).data(data),
    editPass: (id, data) => $app.api.patch([ 'users*/edit-password', id, ]).data(data),
    confirmed: (id) => $app.api.post([ 'orders*/admin-confirmed', id, ]),
    package: (id) => $app.api.post([ 'orders*/package', id, ]),
    transit: (id) => $app.api.post([ 'orders*/inTransit', id, ]),
    forissued: (id) => $app.api.post([ 'orders*/issued', id, ]),
    issued: (id) => $app.api.post([ 'orders*/for-issued', id, ]),

  }

  files = {
    create: (data) => {
      const formData = new FormData()
      $n.each(data, (value, name) => {
        formData.append(name, value)
      })
      return $app.api.post([ 'files', ]).data(formData).config({ headers: { 'Content-Type': 'multipart/form-data', }, })
    },
    delete: (id) => $app.api.delete([ 'files*', id, ]),

  }
  undercategory = {
    get: (id) => $app.api.get([ 'products*', id, ]),
    getAll: () => $app.api.get([ 'products', ]),
    getById: (id) => $app.api.get([ 'under-category*/under', id, ]),
    delete: (id) => $app.api.delete([ 'under-category*', id, ]),

    create: (data) => $app.api.post([ 'under-category/create', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'under-category*', id, ]).data(data),
  }

  products = {
    get: (id) => $app.api.get([ 'products*', id, ]),
    getAll: () => $app.api.get([ 'products', ]),
    getById: (id) => $app.api.get([ 'by*/products', id, ]),
    delete: (id) => $app.api.delete([ 'products*', id, ]),
    getOne: (id) => $app.api.get([ 'products*', id, ]),
    create: (data) => $app.api.post([ 'products', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'products*', id, ]).data(data),
    cdek: () => $app.api.get([ 'cdek/city', ]),

  }

  positions = {
    get: () => $app.api.get([ 'positions', ]),
    delete: (id) => $app.api.delete([ 'positions*', id, ]),
    getOne: (id) => $app.api.get([ 'positions*', id, ]),
    create: (data) => $app.api.post([ 'positions/create', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'positions*', id, ]).data(data),
  }
  bargain = {
    getById: (id) => $app.api.get([ 'by*/bargain', id, ]),
    edit: (id, data) => $app.api.patch([ 'bargain*', id, ]).data(data),
  }

  sellforme = {
    get: () => $app.api.get([ 'sellformes', ]),
    delete: (id) => $app.api.delete([ 'sellformes*', id, ]),
    getOne: (id) => $app.api.get([ 'sellformes*', id, ]),
    edit: (id, data) => $app.api.patch([ 'sellformes*', id, ]).data(data),
  }
  sellerbid = {
    get: (id) => $app.api.get([ 'sellermess*', ]),
  }

  slots = {
    get: () => $app.api.get([ 'slots', ]),
    delete: (id) => $app.api.delete([ 'slots*', id, ]),
    getOne: (id) => $app.api.get([ 'slots*', id, ]),
    create: (data) => $app.api.post([ 'slots/create', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'slots*', id, ]).data(data),
  }
  promotionpackages = {
    get: (id) => $app.api.get([ 'promotion-packages*', id, ]),
    create: (data) => $app.api.post([ 'promotion-packages/create', ]).data(data),
    getAll: () => $app.api.get([ 'promotions', ]),
    getAllAdmin: () => $app.api.get([ 'admin/promotions', ]),
    delete: (id) => $app.api.delete([ 'promotion-packages*', id, ]),
    edit: (id, data) => $app.api.patch([ 'promotion-packages*', id, ]).data(data),
  }
  promocodes = {
    get: () => $app.api.get([ 'promocodes', ]),
    delete: (id) => $app.api.delete([ 'promocodes*', id, ]),
    getOne: (id) => $app.api.get([ 'promocodes*', id, ]),
    create: (data) => $app.api.post([ 'promocodes/create', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'promocodes*', id, ]).data(data),
  }
  categories = {
    get: () => $app.api.get([ 'categories', ]),
    delete: (id) => $app.api.delete([ 'categories*', id, ]),
    getOne: (id) => $app.api.get([ 'categories*', id, ]),
    create: (data) => $app.api.post([ 'categories/create', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'categories*', id, ]).data(data),
  }
  privacypolicy= {
    get: () => $app.api.get([ 'privacypolicy', ]),
    edit: (id, data) => $app.api.patch([ 'privacypolicy*', id, ]).data(data),
  }
  faqs ={
    get: () => $app.api.get([ 'faqs', ]),
    send: (data) => $app.api.post([ 'faqs', ]).data(data),
    delete: (id) => $app.api.delete([ 'faqs*', id, ]),
    edit: (id, data) => $app.api.patch([ 'faqs*', id, ]).data(data),
  }
  socialnet ={
    get: () => $app.api.get([ 'socialnet', ]),
    edit: (id, data) => $app.api.patch([ 'socialnet*', id, ]).data(data),
  }
  notifications = {
    get: (id) => $app.api.get([ 'notifications', id, ]),
    getList: () => $app.api.get([ 'notifications', ]),
    getListUser: () => $app.api.get([ 'userNot/notifications', ]),
    edit: (id, data) => $app.api.patch([ 'check/notifications', id, ]).data(data),
    getListProduct: () => $app.api.get([ 'productNot/notifications', ]),
    check: () => $app.api.get([ 'new/notifications', ]),
    create: (data) => $app.api.post([ 'notifications', ]).data(data),
  }
  lists ={
    getAll: () => $app.api.get([ 'lists', ]),
    get: (id) => $app.api.get([ 'lists*', id, ]),
    create: (data) => $app.api.post([ 'lists/create', ]).data(data),
    delete: (id) => $app.api.delete([ 'lists*', id, ]),
    edit: (id, data) => $app.api.patch([ 'lists*', id, ]).data(data),
  }

  listproducts ={
    getAll: (id) => $app.api.get([ 'list-products*', id, ]),
    get: (id) => $app.api.get([ 'lists*', id, ]),
    create: (data) => $app.api.post([ 'list-product/create', ]).data(data),
    delete: (id) => $app.api.delete([ 'list-product*', id, ]),
    edit: ( data) => $app.api.patch([ 'list-product', ]).data(data),
  }

  lifestyles = {
    getAll: () => $app.api.get([ 'life-style-event', ]),
    get: (id) => $app.api.get([ 'life-style-event/lifestyleevent*', id, ]),
    delete: (id) => $app.api.delete([ 'life-style-event*', id, ]),
    getOne: (id) => $app.api.get([ 'life-style-event*', id, ]),
    create: (data) => $app.api.post([ 'life-style-event/create', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'life-style-event*', id, ]).data(data),
  }
  services = {
    getAll: () => $app.api.get([ 'services', ]),
    get: (id) => $app.api.get([ 'services/services*', id, ]),
    delete: (id) => $app.api.delete([ 'services*', id, ]),
    getOne: (id) => $app.api.get([ 'services*', id, ]),
    create: (data) => $app.api.post([ 'services/create', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'services*', id, ]).data(data),
  }
  landing = {
    getAll: () => $app.api.get([ 'landings', ]),
    get: (id) => $app.api.get([ 'landing*', id, ]),
    delete: (id) => $app.api.delete([ 'landing*', id, ]),
    create: (data) => $app.api.post([ 'landing/create', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'landing*', id, ]).data(data),
  }
  avatars = {
    getAll: () => $app.api.get([ 'avatars', ]),
    get: (id) => $app.api.get([ 'avatars*', id, ]),
    delete: (id) => $app.api.delete([ 'avatars*', id, ]),
    create: (data) => $app.api.post([ 'avatars/create', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'avatars*', id, ]).data(data),
  }
}
